import React, { forwardRef } from 'react'
import { NavLink as RouterLink } from 'react-router-dom'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import {
  List,
  ListItem,
  Button,
  Tooltip,
  Divider
} from '@material-ui/core'
import { AccessControl } from '../../../../../../components/Utils/AccessControl'
import { history } from 'utils'

const useStyles = makeStyles((theme) => ({
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
    color: '#37474f',
  },
  button: {
    color: '#37474f',
    padding: '8px 5px',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    minWidth: 0,
    fontWeight: theme.typography.fontWeightMedium
  },
  buttonOpen: {
    justifyContent: 'flex-start',
    overflow: 'hidden'
  },
  buttonClose: {
    justifyContent: 'center'
  },
  icon: {
    color: '#37474f',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
  },
  iconOpen: {
    marginRight: theme.spacing(2),
  },
  iconClosed: {
    marginRight: 0,
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main
    }
  },
  tooltipText: {
    textAlign: 'center'
  },
  divider: {
    margin: theme.spacing(1, 0)
  },
  tooltipTitle: {
    fontSize: '12px'
  },
}))

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
))

const SidebarNav = (props) => {
  const { pages, className, isOpen, ...rest } = props
  const classes = useStyles()

  const CustomTooltip = ({ disabled, children }) => (
    <Tooltip
      title={
        <span className={classes.tooltipText}>
          <p>Função bloqueada 🤔 </p>
          <p>Clique para completar seu cadastro!</p>
        </span>
      }
      arrow
      disableFocusListener={!disabled}
      disableHoverListener={!disabled}
      disableTouchListener={!disabled}
    >
      {children}
    </Tooltip>
  )

  const NotificationDot = ({ style }) => (
    <span style={{
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: '#DF181B',
      display: 'inline-block',
      flexShrink: 0,
      ...style,
    }} />
  )

  const RenderListItem = ({ page, withCursor = false }) => (
    <ListItem
      style={withCursor ? { cursor: 'not-allowed' } : undefined}
      disabled={page.disabled}
      className={classes.item}
      clicked={page.clicked}
      disableGutters
    >
      <Button
        disabled={page.disabled}
        className={clsx(classes.button, isOpen ? classes.buttonOpen : classes.buttonClose)}
        activeClassName={classes.active}
        component={CustomRouterLink}
        to={page.href}
        onClick={page.onClick}
      >
        <Tooltip title={page.title} classes={{ tooltip: classes.tooltipTitle }}>
          <div
            className={clsx(classes.icon, isOpen ? classes.iconOpen : classes.iconClose)}
            style={{ position: 'relative', display: 'inline-flex' }}
          >
            {page.icon}
            {page.isNew && (
              <NotificationDot style={{ position: 'absolute', top: -2, right: -2 }} />
            )}
          </div>
        </Tooltip>
        {isOpen && (
          <span style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
          }}>
            {page.title}
          </span>
        )}
      </Button>
    </ListItem>
  )

  return (
    <List {...rest} className={clsx(classes.root, className)}>
      {pages.map((page, index) => (
        <React.Fragment key={index}>
          {page.rule !== undefined ? (
            <AccessControl
              rule={page.rule}
              yes={() => (
                <CustomTooltip disabled={page.disabled}>
                  {page.clicked == true ? (
                    <RenderListItem page={page} withCursor />
                  ) : (
                    <RenderListItem page={page} withCursor={!!page.clickedSub} />
                  ) }
                </CustomTooltip>
              )}
            />
          ) : (
            <CustomTooltip disabled={page.disabled}>
              <RenderListItem page={page} withCursor />
            </CustomTooltip>
          )}
          {page.divider && <Divider className={classes.divider} />}
        </React.Fragment>
      ))}
    </List>
  )
}

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired,
  isOpen: PropTypes.bool
}

export default SidebarNav
